<template>
    <div class="qrcode_modal_box">
        <b-modal ref="modal" @hide="hide" id="qrcode_modal" hide-footer centered>
            <div class="qrcode_content">
                <h4 class="text-center">入場QR CODE</h4>
                <div class="text-center">
                    <qriously :value="qrCode" :size="245" style="margin-bottom: 30px;" />
                </div>
                <div class="username text-center">
                    <h5>姓名</h5>
                    <p>{{ student.Name }}</p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'

    export default {
        computed: {
            ...mapGetters('student', [
                'student',
                'showQrCodeModal',
            ]),
            qrCode() {
                return _.get(this.student, 'UnitID', '')
            },
        },
        watch: {
            showQrCodeModal(val) {
                if (val) {
                    this.$refs.modal.show();
                } else {
                    this.$refs.modal.hide();
                }
            },
        },
        methods: {
            ...mapActions('student', [
                'hide',
            ]),
        },
    }
</script>